module.exports = __webpack_public_path__ + "img/tadeu.50d7e996.png";